import { Injectable } from '@angular/core'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { FincartApiService } from 'src/app/builder-services/api/fincart.api.service'

export interface FincartLead {
  name: string
  email: string
  phone: string
  avg_monthly_orders: string
  brand: string
  industry: string
}

/**
 * Fincart onboarding data for the current project.
 *
 * The integrate dialog used to reach the data layer itself; this gives that
 * screen a service of its own, the way every other feature has one.
 */
@Injectable({
  providedIn: 'root'
})
export class FincartService {
  constructor(
    private builderService: BuilderService,
    private fincartApi: FincartApiService,
  ) {}

  private get projectId(): string {
    return String(this.builderService.selectedProject)
  }

  /** The project's stored lead submission, or null if it has never been filled in. */
  getFincartLead(): Promise<Record<string, any> | null> {
    return this.fincartApi.getFincartLead(this.projectId)
  }

  /** Saves the project's lead submission (one row per project). */
  upsertFincartLead(lead: FincartLead): Promise<void> {
    return this.fincartApi.upsertFincartLead(this.projectId, lead)
  }
}
